import { useFetch } from "@hyper-fetch/react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { sdk } from "@/api/sdk";
import { requireSelling } from "@/features/shop/modules/offer-shell/require-selling";
import { OffersList } from "@/features/shop/modules/offers/offers-list";
import { m } from "@/paraglide/messages.js";
import { OfferKind } from "@complete-athlete/enums";

export const Route = createFileRoute("/(private)/offer/packs/")({
  beforeLoad: requireSelling,
  loader: () => ({ crumb: m.offer_tab_packs() }),
  validateSearch: z.object({
    create: z.enum([OfferKind.ENTRY_PACK, OfferKind.TRAINING_PLAN, OfferKind.DIET_PLAN]).optional().catch(undefined),
  }),
  component: PacksPage,
});

function PacksPage() {
  const { create } = Route.useSearch();
  const navigate = Route.useNavigate();
  const { data: settings } = useFetch(sdk.booking.settings.$get);
  return (
    <OffersList
      currency={settings?.currency ?? "PLN"}
      create={create}
      onCreateClosed={() => void navigate({ search: {}, replace: true })}
    />
  );
}
